var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$route.meta.header)?_c('div',{staticClass:"header",style:({ height: `${_vm.shrink ? _vm.shrinkHeight : 80}px` })},[_c('h3',{staticClass:"header-text"},[_vm._v(" "+_vm._s(_vm.$route.meta.header)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }